import {
    selectDoc, selectArr,
    event,
    toggleClass,
    addClass
} from "../utils/utils";

import {addCartItem} from "../helpers/service.cart";

import {initSlider} from "../helpers/service.slider";

import {MiniCart} from "./component.minicart";
import {PCP} from "./component.pcp";
import {lazyLoadShow} from "./component.animate";

const props = {
    html: selectDoc('html'),

    pageContainer: selectDoc('#PageContainer'),
    mainContainer: selectDoc('#pdp'),

    bagBtn: selectDoc('#bag-btn'),
    bagId: selectDoc('#bag-id'),

    recircCards: selectArr('#recirc-module .cards .card'),
    recircModule: selectDoc('#recirc-module'),

    setsCards: selectArr('#sets-module .cards .card'),
    setsModule: selectDoc('#sets-module'),

    isSimpleProduct: selectDoc('#product-main-section.simple-product'),
}

/**
 * Add to cart keepsake box module
 * @returns {Promise<void>}
 */
const initKeepsakeBox = () => {
    if (props.bagBtn) {
        event(props.bagBtn, 'click', function () {
            MiniCart.toggleOverlay();
            addCartItem(props.bagId.value, 1, {
                'name': 'Keepsake Box',
                'id': props.bagId.value,
                'price': selectDoc('#bag-btn .price').innerText,
                'quantity': 1,
            }).then(
                function (response) {
                    response = JSON.parse(response);
                    if (response.status === 200) {
                        MiniCart.redirect()
                    } else {
                        console.log('Error adding to cart!');
                    }
                })
        })
    }
}

/**
 *
 */
const initRecirculation = (module, cards, sliderSelector) => {
    if (cards && cards.length >= 3) {
        if(sliderSelector === '.sets-slider') {
            selectArr('.card', module).map(c => {
                addClass(c, 'active');
            })
        } else {
            let randoms = [],
                index = 0,
                fails = 0;
            while (randoms.length < 3) {
                let r = Math.floor(Math.random() * parseInt(cards.length)) + 1;
                if (randoms.indexOf(r) === -1) {
                    let card = selectDoc(`.card[data-pos="${r}"]`, module)
                    if (card) {
                        toggleClass(card, 'active')
                        index++;
                        randoms.push(r);

                        if (fails > 5) {
                            randoms.push(r);
                        }
                    }
                }
            }
        }

        let removeCards = selectArr('.card:not(.active)', module);
        removeCards.map(removeCard => {
            removeCard.parentNode.removeChild(removeCard);
        })

        let activeCards = selectArr('.card', module),
            slider = selectDoc(`${sliderSelector} .glide__slides`)
        if(slider){
            activeCards.map(card => {
                slider.innerHTML += `<li class="glide__slide">${card.innerHTML}</li>`;
            })
        }

        initSlider(sliderSelector, {
            type: 'carousel',
            perView: 3,
            rewindDuration: 0,
            breakpoints: {
                767: {
                    perView: 1,
                    peek: {
                        before: 0,
                        after: 70
                    },
                }
            }
        });

        selectArr((`.desktop-only .product-card`), module).map(card => {
            let buttons = selectArr((`.desktop-only #${card.id} .color-variants button:not(.disabled)`), module)
            buttons.map(btn => {
                event(btn, 'click', function () {
                    PCP.switchCardColor(card.id , btn.getAttribute('data-color'))
                    $(btn).attr('aria-pressed', 'true');
                    $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('button').attr('aria-pressed', 'false');
                    $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('label').removeClass('d-block').addClass('d-none');
                    $(btn).next().removeClass('d-none').addClass('d-block');
                    $(btn).siblings('button').attr('aria-pressed', 'false');
                })
                PCP.switchCardColor(card.id , 'default', false, false)
                if ($(btn).hasClass("active")) {
                    $(btn).attr('aria-pressed', 'true');
                    $(btn).next().removeClass('d-none').addClass('d-block');
                }
            })
        })

        selectArr((`${sliderSelector} .product-card`)).map(card => {
            let  parentClass = '.glide__slide:not(.glide__slide--clone)'
            if(card.parentNode.className.includes('glide__slide--clone')){
                parentClass = '.glide__slide--clone'
            }

            let buttons = selectArr((`.recirculation-slider ${parentClass} #${card.id} .color-variants button:not(.disabled)`))
            buttons.map(btn => {
                event(btn, 'click', function () {
                    PCP.switchCardColor(card.id , btn.getAttribute('data-color'))
                })
                PCP.switchCardColor(card.id , 'default', false, false)
            })
        })

    } else {
        if (module) {
            module.style.display = 'none'
        }
    }
}

/**
 *
 */
const initSelectedPairings = () => {
    let peek = 70;
    if(selectArr(`#ws-pdp-pairings .desktop-only .product-card`).length <= 1) {
        peek = 0
    }

    initSlider('.selected-pairing-slider', {
        type: 'slider',
        perView: 1,
        rewind: true,
        bound: true,
        peek: {
            before: 0,
            after: peek
        }
    });

    selectArr((`#ws-pdp-pairings .desktop-only .product-card`)).map(card => {
        let buttons = selectArr((`#ws-pdp-pairings .desktop-only #${card.id} .color-variants button:not(.disabled)`))
        buttons.map(btn => {
            event(btn, 'click', function () {
                PCP.switchCardColor(card.id , btn.getAttribute('data-color'))
                $(btn).attr('aria-pressed', 'true');
                $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('button').attr('aria-pressed', 'false');
                $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('label').removeClass('d-block').addClass('d-none');
                $(btn).next().removeClass('d-none').addClass('d-block');
                $(btn).siblings('button').attr('aria-pressed', 'false');
            })
            PCP.switchCardColor(card.id , 'default', false, false)
            if ($(btn).hasClass("active")) {
                $(btn).attr('aria-pressed', 'true');
                $(btn).next().removeClass('d-none').addClass('d-block');
            }
        })
    })

    selectArr((`#ws-pdp-pairings .mobile-only .product-card`)).map(card => {
        let  parentClass = '.glide__slide:not(.glide__slide--clone)'
        if(card.parentNode.className.includes('glide__slide--clone')){
            parentClass = '.glide__slide--clone'
        }

        let buttons = selectArr((`#ws-pdp-pairings .mobile-only ${parentClass} #${card.id} .color-variants button:not(.disabled)`))
        buttons.map(btn => {
            event(btn, 'click', function () {
                PCP.switchCardColor(card.id , btn.getAttribute('data-color'))
                $(btn).attr('aria-pressed', 'true');
                $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('button').attr('aria-pressed', 'false');
                $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('label').removeClass('d-block').addClass('d-none');
                $(btn).next().removeClass('d-none').addClass('d-block');
                $(btn).siblings('button').attr('aria-pressed', 'false');
            })
            PCP.switchCardColor(card.id , 'default', false, false)
            if ($(btn).hasClass("active")) {
                $(btn).attr('aria-pressed', 'true');
                $(btn).next().removeClass('d-none').addClass('d-block');
            }
        })
    })
}

const initializer = () => {
    initKeepsakeBox();
    initRecirculation(props.recircModule, props.recircCards, '.recirculation-slider');
    initRecirculation(props.setsModule, props.setsCards, '.sets-slider');
    initSelectedPairings()
}

export const PDPSections = {
    init: () => initializer()
}
